var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import TableSortLabel from "@mui/material/TableSortLabel";
var useStyles = makeStyles(function (_a) {
    var _b = _a.palette, grey = _b.grey, primary = _b.primary, spacing = _a.spacing;
    return ({
        icon: {
            color: grey[500],
            opacity: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            "&>*": {
                marginBottom: spacing(-1),
            },
            "&>*:last-child": {
                marginBottom: 0,
                marginTop: spacing(-1),
            },
        },
        active: {},
        root: {
            display: "flex",
            "&$active $icon >*": {
                color: grey[500],
                "&:last-child": {
                    color: primary.main,
                },
            },
        },
    });
});
var IconComponent = function (_a) {
    var className = _a.className;
    return (React.createElement("div", { className: className },
        React.createElement(ArrowDropUpIcon, null),
        React.createElement(ArrowDropDownIcon, null)));
};
var CustomTableSortLabel = function (_a) {
    var children = _a.children, tslProps = __rest(_a, ["children"]);
    var classes = useStyles();
    return (React.createElement(TableSortLabel, __assign({ component: "div", classes: classes, IconComponent: IconComponent }, tslProps), children));
};
export default CustomTableSortLabel;
//# sourceMappingURL=TableSortLabel.js.map